import { render, staticRenderFns } from "./ModalUnresolved.vue?vue&type=template&id=56bb4b9c&"
import script from "./ModalUnresolved.vue?vue&type=script&lang=js&"
export * from "./ModalUnresolved.vue?vue&type=script&lang=js&"
import style0 from "./ModalUnresolved.vue?vue&type=style&index=0&id=56bb4b9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports